var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 560 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4:294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M541.21 43.5549L560 42.9548L558.601 0L184.179 12.0513L185.578 55.0061L250.541 52.9059V113.529H262.201V52.5392L279.459 51.9892V113.529H291.119V51.6057L529.6 43.9382V256.029H184.795V299.017H559.833V256.045H541.227L541.21 43.5549ZM196.222 23.3359L547.324 12.0346L547.973 31.6702L196.855 42.9715L196.222 23.3359ZM548.157 287.349H196.439V267.713H548.157V287.349Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.053 210.673H123.847V251.978H349.053V210.673ZM337.393 240.31H135.507V222.341H337.393V240.31Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.708 206.59H388.93V165.285H163.708V206.59ZM175.368 176.953H377.27V194.922H175.368V176.953Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.847 161.218H349.053V119.913H123.847V161.218ZM135.507 131.581H337.393V149.55H135.507V131.581Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.817 29.7259L94.5317 36.7836L125.141 77.1084L134.426 70.0507L103.817 29.7259Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.412 104.572L2.97998 115.364L92.8031 152.301L97.2351 141.509L7.412 104.572Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5112 186.994L-0.132812 203.761L2.11416 215.21L87.7582 198.444L85.5112 186.994Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1395 247.99L29.2964 288.561L36.5661 297.684L87.4093 257.112L80.1395 247.99Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.345 107.862L410.251 190.471C409.824 191.363 409.628 192.349 409.684 193.337C409.739 194.325 410.043 195.283 410.568 196.122C411.097 196.967 411.835 197.662 412.71 198.141C413.585 198.619 414.568 198.866 415.565 198.856H459.973V187.188H424.876L460.906 112.946L450.345 107.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.119 221.725V233.393H473.349L507.197 184.404L497.619 177.77L467.236 221.725H438.119Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.951 72.7038L406.756 129.769L418.023 132.773L433.218 75.708L421.951 72.7038Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.908 69.4856L470.066 131.722L481.365 134.602L497.207 72.3656L485.908 69.4856Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4:294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 299,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.cb70d97d678440dda786f5e32dbb435c.svg";
export { ForwardRef as ReactComponent };